module.exports = __webpack_public_path__ + "img/REG_ALIM_SANS_POISSON.5df26968.svg";